// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CUDv","rootNoMargin":"styles_rootNoMargin__2oxob"};